import {request} from '@/utils/http'

export default {
    index:(params = {}) => request.get('/plugin',{params}),
    add:(data) => request.post('/plugin',data),
    delete:(id) => request.delete(`/plugin/${id}`,),
    update:(id,data) => request.put(`/plugin/${id}`,data),
}